module.exports = __webpack_public_path__ + "img/call-icon.d356639b.svg";